import { render, staticRenderFns } from "./BookCard.vue?vue&type=template&id=29750474&scoped=true"
import script from "./BookCard.vue?vue&type=script&lang=js"
export * from "./BookCard.vue?vue&type=script&lang=js"
import style0 from "./BookCard.vue?vue&type=style&index=0&id=29750474&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29750474",
  null
  
)

export default component.exports